import type { FC } from "react";
import { Heading2 } from "@/components/podkit/typography/Headings";
import { useListAgentExecutions, type PlainAgentExecution } from "@/queries/agent-queries";
import { AgentExecutionCard } from "@/components/ai/AgentExecutionCard";
import { cn } from "@/components/podkit/lib/cn";
import { ErrorMessage } from "@/components/ErrorMessage";

export const RecentAgentExecutions: FC = () => {
    const { data, isPending, error } = useListAgentExecutions();
    const hasAgentExecutions = (data?.agentExecutions.length ?? 0) > 0;
    return (
        <div
            data-testid="recent-agent-executions"
            className={cn("hidden duration-300 animate-in fade-in", {
                block: !isPending,
            })}
        >
            {(hasAgentExecutions || error) && (
                <>
                    <div className="flex justify-between">
                        <Heading2 className="text-lg">Recent agent executions</Heading2>
                        {/* Status filter dropdown will come here later */}
                    </div>
                    <ErrorMessage error={error} data-testid="recent-agent-executions-error" />
                    <div className="flex flex-col gap-4 pb-2 pt-5">
                        <RecentAgentExecutionsList agentExecutions={data?.agentExecutions || []} />
                    </div>
                </>
            )}
        </div>
    );
};

const RecentAgentExecutionsList: FC<{ agentExecutions: PlainAgentExecution[] }> = ({ agentExecutions }) => {
    return (
        <div data-testid="recent-agent-executions-list" className="flex flex-col gap-4">
            {agentExecutions.map((agentExecution) => (
                <AgentExecutionCard key={agentExecution.id} agentExecution={agentExecution} />
            ))}
        </div>
    );
};
